// extracted by mini-css-extract-plugin
export default {"general":"List_general--J5h","title":"List_title--uEy"};